import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';

import type {GetLead_lead as Lead, SessionUser} from 'nutshell-graphql-types';

import {LeadHeaderContainer} from '../header/lead-header-container';
import {LeadSubheaderContainer} from '../header/lead-subheader-container';

import {RightSection} from './components';

import styles from './header.module.css';

type Props = {
    lead: Lead;
    user?: SessionUser | null | undefined;
    onUpdateLeadName: (arg1: string) => Promise<any>;
    fetchTags: (arg1: string) => Promise<any>;
    onUpdateLeadConfidence: (arg1: number) => void;
    onUpdateLeadCreatedDate: (arg1?: Date | null | undefined) => void;
    onUpdateLeadDueDate: (arg1?: Date | null | undefined) => void;
    onUpdateLeadClosedDate: (arg1?: Date | null | undefined) => void;
};

export function Header(props: Props) {
    return (
        <div className={styles['header-container']}>
            <Stack isHorizontal={true} justifyContent='space-between' spacing={48}>
                <div className={styles['left-section']}>
                    <LeadHeaderContainer
                        lead={props.lead}
                        user={props.user}
                        onUpdateLeadName={props.onUpdateLeadName}
                        fetchTags={props.fetchTags}
                        showButtons={false}
                        showValue={false}
                    />
                    <LeadSubheaderContainer
                        lead={props.lead}
                        onUpdateLeadConfidence={props.onUpdateLeadConfidence}
                        onUpdateLeadCreatedDate={props.onUpdateLeadCreatedDate}
                        onUpdateLeadDueDate={props.onUpdateLeadDueDate}
                        onUpdateLeadClosedDate={props.onUpdateLeadClosedDate}
                    />
                </div>
                <RightSection lead={props.lead} />
            </Stack>
        </div>
    );
}
